import request from '@/utils/request'
// 获取x相关推荐
export function getDetail(url,query){
  return request({
    url:'/ich/'+url+'/recommend',
    method: 'get',
    params: query
})
}
